import React from "react";
import './Notifications.scss'

/* Placeholder rows shaped like the notification cards, so the panel does not
   jump when the real ones arrive. */
const NotificationSkeleton = ({ rows = 4 }) => (
    <div className="unread_notifications" aria-hidden="true">
        {Array.from({ length: rows }).map((_, i) => (
            <div className="notification_space_unread notif-skeleton" key={i}>
                <div className="notif-row">
                    <div className="notif-icon"><span className="sk sk-icon" /></div>
                    <div className="notif-body">
                        <div className="notif-head">
                            <span className="sk sk-title" />
                            <span className="sk sk-date" />
                        </div>
                        <span className="sk sk-line" />
                        <span className="sk sk-line sk-line--short" />
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export default NotificationSkeleton;
